<div class="rdb">
  <!-- Left pane: category browse + product grid -->
  <section class="rdb__left" aria-label="Menu catalog">
    <!-- Barcode & Product Search Bar -->
    <ng-content select="[search-bar]"></ng-content>

    <!-- Category tabs strip -->
    <app-category-tabs
      [categories]="categories"
      [selectedCategoryId]="selectedCategoryId"
      [visibleCount]="10"
      (categorySelected)="onCategorySelected($event)"
    ></app-category-tabs>

    <!-- Product grid -->
    <app-product-grid
      [products]="filteredCatalog"
      [categoryLabel]="categoryLabel"
      [showCount]="true"
      [cartItems]="cartProducts"
      [isUnitPriceInclTax]="isUnitPriceInclTax"
      (productClicked)="productSelected.emit($event)"
      (increaseQty)="increaseQty.emit($event)"
      (decreaseQty)="decreaseQty.emit($event)"
    ></app-product-grid>

    <!-- Sticky Restaurant Quick Actions Footer -->
    <footer class="rdb-footer" *ngIf="actions && actions.length > 0">
      <div class="rdb-footer__actions">
        <!-- Quick Action Buttons -->
        <button
          *ngFor="let action of getQuickActions()"
          type="button"
          class="rdb-footer__btn"
          [class.rdb-footer__btn--disabled]="isDisabled(action)"
          (click)="onActionClick(action)"
          [title]="action.title || action.label(context)"
        >
          <i [class]="action.icon"></i>
          <span class="rdb-footer__btn-label">{{ action.label(context) }}</span>
          <span class="rdb-footer__btn-key">{{ action.shortcutKey }}</span>
        </button>

        <!-- More Actions Popover Dropdown -->
        <div class="rdb-footer__more-wrap">
          <button
            type="button"
            class="rdb-footer__btn rdb-footer__btn--more"
            [class.rdb-footer__btn--active]="isMorePopoverOpen"
            (click)="toggleMorePopover($event)"
            title="More POS Actions & Shortcuts"
          >
            <!-- <i class="pi pi-ellipsis-h"></i> -->
            <span class="rdb-footer__btn-label">Quick Actions</span>
            <i class="pi pi-chevron-up rdb-footer__more-chevron" [class.rdb-footer__more-chevron--open]="isMorePopoverOpen"></i>
          </button>

          <!-- Dropdown / Popover Menu -->
          <div class="rdb-popover" *ngIf="isMorePopoverOpen" (click)="$event.stopPropagation()">
            <div class="rdb-popover__header">
              <span class="rdb-popover__title">POS Actions & Shortcuts</span>
              <button type="button" class="rdb-popover__close" (click)="closeMorePopover()">
                <i class="pi pi-times"></i>
              </button>
            </div>
            <div class="rdb-popover__list">
              <div
                *ngFor="let action of getPopoverActions()"
                class="rdb-popover__item"
                [class.rdb-popover__item--disabled]="isDisabled(action)"
                (click)="onActionClick(action); closeMorePopover()"
              >
                <div class="rdb-popover__item-left">
                  <div class="rdb-popover__icon-badge">
                    <i [class]="action.icon"></i>
                  </div>
                  <span class="rdb-popover__item-label">{{ action.label(context) }}</span>
                </div>
                <span class="rdb-popover__item-key">{{ action.shortcutKey }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </section>
</div>

